import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  PageListBean,
  RestReadRequest,
  RestDebitMemoBeanRequest,
  RestVendorListRequest,
  DebitMemoSearchCriteria,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
// import { RestDebitMemoBeanRequest } from "../lookup/RestDebitMemoBeanRequest.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { VendorService } from "../services/VendorService.js";
import { DebitMemoService } from "../services/DebitMemoService.js";
import { VendorLookupHandler } from "./VendorLookupHandler.js";
export class DebitMemoLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, searchCode, status) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.searchCode = searchCode;
    this.status = status;
    let resetCriteria = new DebitMemoSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let vendorLookupLookupCriteria = new DebitMemoSearchCriteria();
    vendorLookupLookupCriteria.companyCode = this.companyCode;
    vendorLookupLookupCriteria.vendorCode = this.searchCode;
    let newCriteria = new DebitMemoSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = DebitMemoLookupCriteraHandler(
      companyCode,
      vendorLookupLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      vendorLookupLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getVendorInvoiceStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Status", "debitMemoStatus", 0, false); //1
    this.addColumnDefinition("VendorCode", "vendorCode", 0, false); //3
    this.addColumnDefinition("VendorName", "vendorName", 0, false); //3
    this.addColumnDefinition("DebitMemoType", "debitMemoType", 0, false); //3
    this.addColumnDefinition("Amount", "debitMemoAmount", 1, false); //3
    this.addColumnDefinition("PurchaseOrder", "purchaseOrderNumber", 0, false); //3
    //this.addColumnDefinition("GrandTotalAmount", "grandTotalAmount", 1, false);
  }
  loadDebitMemoList = (lookup_dialog, pageNumber, searchCriteria) => {
    let debitMemo_criteria = new DebitMemoSearchCriteria(); //To be fetched from CriteriaHandler
    debitMemo_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      debitMemo_criteria.debitMemoNumber = searchCriteria.debitMemoNumber;
      debitMemo_criteria.debitMemoNumberContains =
        searchCriteria.debitMemoNumberContains;
      // debitMemo_criteria.vendorCode = searchCriteria.vendorCode;
      debitMemo_criteria.debitMemoNumberStartsWith = searchCriteria.debitMemoNumberStartsWith;
      debitMemo_criteria.debitMemoType = searchCriteria.debitMemoType;
      debitMemo_criteria.purchaseOrderNumber = searchCriteria.purchaseOrderNumber;
      //  debitMemo_criteria.debitMemoStatus = searchCriteria.debitMemoStatus;
      // debitMemo_criteria.vendorType = searchCriteria.vendorType;
      if (!isEmptyString(this.searchCode)) {
        debitMemo_criteria.vendorCode = this.searchCode;
      } else {
        debitMemo_criteria.vendorCode = searchCriteria.vendorCode;
      }
      if (!isEmptyString(this.status)) {
        debitMemo_criteria.debitMemoStatus = this.status;
      } else {
        debitMemo_criteria.debitMemoStatus = searchCriteria.debitMemoStatus;
      }
    }
    let debitMemo_pageList = new PageListBean();
    debitMemo_pageList.pageSize = 50; //TODO --> Fetch from Config
    debitMemo_pageList.pageNumber = pageNumber;
    debitMemo_pageList.currentPage = pageNumber;
    let debitMemo_requestInput = new RestDebitMemoBeanRequest();
    debitMemo_requestInput.pageInput = debitMemo_pageList;
    debitMemo_requestInput.searchCriteria = debitMemo_criteria;
    DebitMemoService.getDebitMemoPageList(
      debitMemo_requestInput,
      (response) =>
        this.loadDebitMemoListResponse(response, lookup_dialog),
      this.loadDebitmemoListError
    );
  };
  loadDebitMemoListResponse = (response, lookup_dialog) => {
    let vendorList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.debitMemoPageList != null &&
      response.data.debitMemoPageList.debitMemos !== null
    ) {
      vendorList = response.data.debitMemoPageList.debitMemos;
      totalCount = response.data.debitMemoPageList.totalCount;
      currentPageNumber = response.data.debitMemoPageList.currentPage;
      pageSize = response.data.debitMemoPageList.pageSize;
      vendorList.map((vl) => {
        vl.status = ModuleUtils.getDebitMemoStatusCaption(vl.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = vendorList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadDebitmemoListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.vendorInvoiceCode)) {
      if (!isEmptyString(filterText)) {
        search.vendorInvoiceCode = filterText;
        this.searchCriteria = new DebitMemoSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadDebitMemoList(lookup_dialog, pageNumber, search);
    }
  }
}
const DebitMemoLookupCriteraHandler = (
  companyCode,
  vendorLookupLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new DebitMemoSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let vendorLookupHandler = new VendorLookupHandler(companyCode, "Vendor");
      this.setState({ vendorLookupHandler: vendorLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new DebitMemoSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };

    vendorCodeOnChange = (e) => {
      let vendorCode = e.target.value;
      this.state.showAutoCompleteVendorList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      if (isEmpty(vendorCode)) {
        this.state.showAutoCompleteVendorList = false;
        let showAutoCompleteList = this.state.showAutoCompleteVendorList;
        let criteria = this.state.searchCriteria;
        criteria.vendorCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: criteria,
          vendorPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "vendorCode" &&
        showAutoCompleteList === true &&
        vendorCode !== ""
      ) {
        this.readVendorBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetVendorDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      if (response.data != null && response.data.vendor != null) {
        let vendorData = response.data.vendor;
        if (!isEmpty(vendorData)) {
          criteria.vendorCode = vendorData.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetVendorDetail = (vendorCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = vendorCode;
      input.isLoadChildren = true;
      VendorService.readVendor(
        input,
        this.readandsetVendorDetailResponse,
        this.errorCallBack
      );
    };
    readVendorBySearchString(searchString) {
      let searchCriteria = new VendorSearchCriteria();
      searchCriteria.companyCode = companyCode;

      searchCriteria.vendorCodeStartsWith = searchString;
      searchCriteria.vendorNameContains = searchString;
      let pageList = new PageListBean();
      pageList.pageSize = 100;
      let input = new RestVendorListRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      VendorService.getVendorPageList(
        input,
        this.readByVendorCodeResponse,
        this.errorCallBack
      );
    }
    readByVendorCodeResponse = (response) => {
      if (
        response.data != null &&
        response.data.vendorPageList != null &&
        response.data.vendorPageList.vendors != null
      ) {
        let vendorCodeData = response.data.vendorPageList.vendors;
        let simpleAutoCompleteList = new Array();
        if (vendorCodeData.length > 0 && vendorCodeData != null) {
          vendorCodeData.map((vendorCode) => {
            let simpleItemBean = {
              code: vendorCode.code,
              description: vendorCode.description,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          vendorPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    };
    vendorCodeEnterKeyEventHandler = (e) => {
      let vendorCode = e.target.value;
      this.readandsetVendorDetail(vendorCode);
      this.setState({
        vendorPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteVendorList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
    };

    errorCallBack = (error) => {
      ShowError(error);
    };

    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>DebitMemo</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="debitMemoNumber"
                  name="debitMemoNumber"
                  onChange={this.onChange}
                  value={searchCriteria.debitMemoNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>DebitMemoContains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="debitMemoNumberContains"
                  name="debitMemoNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.debitMemoNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>DebitMemoStartWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="debitMemoNumberStartsWith"
                  name="debitMemoNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.debitMemoNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Type</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="debitMemoType"
                  name="debitMemoType"
                  onChange={this.onChange}
                  value={searchCriteria.debitMemoType}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Vendor</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="vendorCode"
                  name="vendorCode"
                  onChange={this.vendorCodeOnChange}
                  value={searchCriteria.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteVendorList}
                  showAutoCompleteList={this.state.showAutoCompleteVendorList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="debitMemoStatus"
                  value={searchCriteria.debitMemoStatus}
                >
                  <option value={""}></option>
                  <option value={"O"}>Open</option>
                  <option value={"A"}>Approved</option>
                  <option value={"P"}>PartiallyClosed</option>
                  <option value={"C"}>PartiallyUsedApproved</option>
                  <option value={"F"}>Finished</option>
                  <option value={"X"}>Cancel</option>
                </FormControl>
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <FormLabel>Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="createdDate"
                  name="createdDate"
                  onChange={this.onChange}
                  value={searchCriteria.createdDate}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>Due Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="invoiceDueDate"
                  name="invoiceDueDate"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceDueDate}
                />
              </Col>
            </Row> */}

            {/* <Row>
              <Col>
                <FormLabel>Invoice From Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="invoiceFromDate"
                  name="invoiceFromDate"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceFromDate}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="invoiceToDate"
                  name="invoiceToDate"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceToDate}
                />
              </Col>
            </Row> */}

            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
